module.exports = __webpack_public_path__ + "static/media/efficiency-amico-business.cd19438e.svg";